import React from 'react';
import PropTypes from 'prop-types';
import Card from 'components/ui/card/Card';
import CardText from 'components/ui/card/CardText';
import Header from 'components/ui/general/Header';
import ProfileForm from './ProfileForm';
import Title from 'components/ui/general/Title';
import authHelper from 'helpers/auth';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import utils from 'helpers/utils';
import { connect } from 'react-redux';
import { fetchProfile } from 'store/actions/users/fetchProfile';
import { updateProfile } from 'store/actions/users/updateProfile';

class Profile extends React.Component {
    componentDidMount() {
        const {
            data,
            fetch,
        } = this.props;

        if (utils.isEmpty(data)) {
            fetch();
        }
    }

    handleSubmitForm = (formValues) => {
        const {
            update,
        } = this.props;

        return new Promise((resolve) => {
            update({
                callback: () => {
                    resolve();
                },
                formValues: formValues,
            });
        });
    }

    render() {
        const {
            data,
            translate,
        } = this.props;

        if (utils.isEmpty(data)) {
            return null;
        }

        return (
            <div>
                <Header>
                    <Title title={ translate('resources.profile.name') } />
                </Header>

                <Card>
                    <CardText>
                        <ProfileForm
                            data={ data }
                            handleSubmitForm={ this.handleSubmitForm }
                        />
                    </CardText>
                </Card>
            </div>
        );
    }
}

Profile.propTypes = {
    data: PropTypes.object,
    fetch: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    update: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const userId = authHelper.getUserId();

    return {
        data: state.users.data[userId],
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetch: () => {
            dispatch(fetchProfile());
        },
        update: (values) => {
            dispatch(updateProfile(values));
        },
    };
};

const enhance = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    translate,
);

export default enhance(Profile);



// WEBPACK FOOTER //
// ./src/pages/profile/ProfileContainer.js